const RecipeSearchItemLoading = () => (
  <div className="animate-pulse flex space-x-4 w-full mb-3">
    <div className="flex-1 space-y-6 py-1">
      <div className="space-y-3 flex">
        <div className="w-[120px] h-[90px] bg-gray-300 rounded col-span-2 mr-[10px]"></div>
        <div className="w-[calc(100%-120px)] !mt-[0px]">
          <div className="h-3 bg-gray-300 rounded col-span-2"></div>
          <div className="mt-[10px]">
              <div className="h-3 bg-gray-300 rounded col-span-2"></div>
              <div className="h-3 bg-gray-300 rounded col-span-2 mt-[5px]"></div>
          </div>
          <div className="mt-[20px] flex">
            <div className="h-3 bg-gray-300 rounded w-[30px] mr-[20px]"></div>
            <div className="h-3 bg-gray-300 rounded w-[30px] mr-[20px]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default RecipeSearchItemLoading
